export const gatherInfoForm = [{
  type: 'input',
  field: 'payee_name',
  label: '收款方',
  required: true
}, {
  type: 'input',
  field: 'open_account_bank',
  label: '开户银行',
  required: true
}, {
  type: 'input',
  field: 'open_account_bank_branch',
  label: '开户银行支行',
  required: true
}, {
  type: 'input',
  field: 'open_account_place',
  label: '开户地',
  required: true
}, {
  type: 'input',
  field: 'bank_account',
  label: '银行账号',
  required: true
}, {
  type: 'radio',
  field: 'is_need_receipt',
  label: '需要银行回单',
  required: true,
  options: [
    {id: 1, name: '是'},
    {id: 2, name: '否'}
  ]
}, ];

export const backInfoFormModal = [{
  type: 'textarea',
  field: 'reason',
  label: '拒绝原因:',
  required: true
}, ]

export const agreeInfoFormModal = [{
  type: 'textarea',
  field: 'reason',
  label: '备注:',
  required: false
}, ]